import Error500Icon from '@/icons/error_500.svg'

export default function ServerErrorPage() {
  return (
    <div className="container mt-20 mb-24 page_errors">
      <a className="flex justify-center">
        <img src={Error500Icon} alt="Error 404" />
      </a>
      <div className="text-center mx-auto w-9/12 md:w-full">
        <h1 className="leading-6 z-10 -mt-20 md:-mt-12 mb-5 text-gray-900 text-xl md:text-3xl text-center">
          Tenemos un problema con el servidor
        </h1>
        <p className="md:leading-6 text-gray-900 md:text-xl text-base">
          Ya lo estamos arreglando. Por favor, regresa en unos minutos.
        </p>
      </div>
    </div>
  )
}